import { LANGS, setLang } from "../i18n";
import { useGame } from "../store";

/** English / Українська. Switching redraws the interface at once. */
export function LangSwitch() {
  const lang = useGame((s) => s.lang);
  return (
    <div className="row lang-switch" role="group" aria-label="Language / Мова" data-testid="lang-switch">
      {LANGS.map((l) => (
        <button key={l.id} className={`btn small ${lang === l.id ? "primary" : "ghost"}`} aria-pressed={lang === l.id} onClick={() => { setLang(l.id); useGame.setState({ lang: l.id }); }} data-testid={`lang-${l.id}`}>
          {l.name}
        </button>
      ))}
    </div>
  );
}
